/**
 *  @class
 *  @function FreeShippingProgressBar
 */

if (!customElements.get('free-shipping-progress-bar')) {
  let currentPercent = 0;

  class FreeShippingProgressBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.updateStatus();
    }

    updateStatus() {
      const remainingInfo = this.querySelector('.free-shipping__info-remaining');
      const eligibilityInfo = this.querySelector('.free-shipping__info-eligibility');
      const cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
      const currencyRate = Shopify.currency.rate || 1;
      const messageTemplate = this.dataset.messageTemplate || 'Spend {{ amount }} more and get {{ reward }}!';
      let milestones = [];

      try {
        milestones = JSON.parse(this.dataset.milestones || '[]');
      } catch (e) {
        milestones = [];
      }

      milestones = milestones
        .map((m) => ({
          amount: Math.round(parseInt(m.amount, 10) * currencyRate),
          label: m.label || '',
        }))
        .filter((m) => m.amount > 0)
        .sort((a, b) => a.amount - b.amount);

      const nextMilestone = milestones.find((m) => cartTotal < m.amount) || null;
      const milestoneEls = this.querySelectorAll('.free-shipping__milestone');

      milestoneEls.forEach((el) => {
        const amount = Math.round(parseInt(el.dataset.amount, 10) * currencyRate);

        el.classList.remove('is-unlocked', 'is-active', 'is-locked');

        if (cartTotal >= amount) {
          el.classList.add('is-unlocked');
        } else {
          el.classList.add('is-locked');
        }
      });

      if (nextMilestone) {
        const remainingAmount = Math.max(nextMilestone.amount - cartTotal, 0);
        const currencyFormat = window.theme.settings.money_with_currency_format || '${{amount}}';
        const amountHtml = '<strong>' + formatMoney(remainingAmount, currencyFormat) + '</strong>';
        const reward = (nextMilestone.label || '').toLowerCase();

        remainingInfo.innerHTML = messageTemplate
          .replace(/\{\{\s*amount\s*\}\}/g, amountHtml)
          .replace(/\{\{\s*reward\s*\}\}/g, reward);

        remainingInfo.style.display = 'block';
        eligibilityInfo.style.display = 'none';
      } else {
        remainingInfo.style.display = 'none';
        eligibilityInfo.style.display = 'block';
      }

      this.animateProgressBar(this.getProgressPercent(cartTotal, milestones) / 100);
    }

    getProgressPercent(cartTotal, milestones) {
      const n = milestones.length;
      if (n === 0 || cartTotal <= 0) return 0;

      const last = milestones[n - 1];
      if (cartTotal >= last.amount) return 100;

      let prevAmount = 0;
      let prevPos = 0;

      for (let i = 0; i < n; i++) {
        const amount = milestones[i].amount;
        const pos = i === n - 1 ? 100 : ((i + 0.5) / n) * 100;

        if (cartTotal <= amount) {
          const span = amount - prevAmount;
          if (span <= 0) return pos;
          const t = (cartTotal - prevAmount) / span;
          return prevPos + t * (pos - prevPos);
        }

        prevAmount = amount;
        prevPos = pos;
      }

      return 100;
    }

    animateProgressBar(progressPercentage) {
      const targetPercent = progressPercentage * 100;
      const startPercent = currentPercent;
      const duration = 200;
      const startTime = performance.now();
      const ease = (t) => t * (2 - t);

      const animate = (time) => {
        const elapsed = time - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = ease(progress);

        currentPercent = startPercent + (targetPercent - startPercent) * easedProgress;
        this.style.setProperty('--percent', `${currentPercent}%`);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          currentPercent = targetPercent;
          this.style.setProperty('--percent', `${currentPercent}%`);
        }
      };

      requestAnimationFrame(animate);
    }
  }

  customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);
}
